import { FC, useEffect } from "react"
import { ControlProps } from "@jsonforms/core"
import { withJsonFormsControlProps } from "@jsonforms/react"
import { Box } from "@/ui-component/mui.components"
import { UText } from "@/ui-component/components"

const InputSummary: FC<{ label: string; inputVal: string }> = ({
  label,
  inputVal,
}) => {
  const summaryStyle = {
    width: 316,
    ml: 1,
    lineHeight: "16px",
    color: "text.primary",
    whiteSpace: "break-spaces",
  }

  return (
    <>
      <Box
        className="summary-data-row"
        sx={{ py: 1, mb: "4px", display: "flex", flexDirection: "row", pl: 1, maxWidth: "560px" }}
      >
        <UText
          variant={"body2"}
          sxProp={{
            width: "200px",
            color: "rgba(0, 0, 0, 0.60)",
          }}
        >
          {label}
        </UText>
        <Box sx={{flexGrow:1}}>
          {inputVal && (
            <>
              <UText
                component={"div"}
                variant={"subtitle2"}
                sxProp={{
                  ...summaryStyle,
                  //   fontWeight: schema.fontweight,
                  wordWrap: "break-word",
                }}
              >
                {inputVal}
              </UText>
            </>
          )}
        </Box>
      </Box>
    </>
  )
}

export default InputSummary
